import { render } from "./PWayHome.vue?vue&type=template&id=307c53bb&scoped=true"
import script from "./PWayHome.vue?vue&type=script&lang=js"
export * from "./PWayHome.vue?vue&type=script&lang=js"

import "./PWayHome.vue?vue&type=style&index=0&id=307c53bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307c53bb"]])

export default __exports__